<!--<ng-container *ngIf="initialized">-->
<!--    <cr-customer-comments [customerObjectId]="connectedObjectId" *ngIf="connectedObjectId"></cr-customer-comments>-->
<!--</ng-container>-->

@if (initialized) {
    @if (activity?.objectId) {
        <cr-customer-comments
                [customerObjectId]="activity?.objectId"
        ></cr-customer-comments>
    }
}